// extracted by mini-css-extract-plugin
export default {"container":"ljokvC","iconWrapper":"KGA3Wn"};